import React, { useEffect, useState } from 'react';
import { Button, Card, Col, DatePicker, Form, Image, Input, Modal, Popover, Row, Select, Spin, Switch, Table, message } from 'antd';
import { getRewarddata, getusertree } from '../../../../utils/API';

const RewordStatus: React.FC = () => {
    const [PageData, setPageData] = useState<any[]>([]);

    const customerId = localStorage.getItem("customerId");
    const userId = customerId?.replace(/"/g, "");

    // useEffect(() => {
    
    useEffect(() => {
            getRewarddata().then((res) => {
                setPageData(res.eligibleRewards);
            });
    }, [userId]);

    const columns = [
        {
            title: <div style={{ fontWeight: 'bold', fontSize: "15px" }}>Club</div>,
            dataIndex: 'club',
            render: (text: any) => <span style={{ fontWeight: 'bold', fontSize: "15px" }}>{text}</span>
        },
        {
            title: <div style={{ fontWeight: 'bold', fontSize: "15px" }}>Criteria</div>,
            dataIndex: 'criteria',
            render: (text: any) => <span style={{ fontSize: "15px", color: "#a6a6a6" }}>{text}</span>
        },
        {
            title: <div style={{ fontWeight: 'bold', fontSize: "15px" }}>Eligibility</div>,
            dataIndex: 'eligibility', // Corrected the key name
            render: (text: any) => <span style={{ fontSize: "15px", color: "#a6a6a6" }}>{text}</span>
        },
        {
            title: <div style={{ fontWeight: 'bold', fontSize: "15px" }}>Pairs</div>,
            dataIndex: 'pairs',
            render: (text: any) => <span style={{ fontSize: "15px", color: "#a6a6a6" }}>{text}</span>
        },
    ];

    const now = new Date();
    let previousMonth = now.getMonth() - 1;
    let previousYear = now.getFullYear();

    if (previousMonth === -1) {
        previousMonth = 11; // December
        previousYear--;
    }

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentMonth = monthNames[previousMonth];
    const currentYear = previousYear;

    const monthClosingTitle = `${currentMonth}-${currentYear} Month Closing`;

    return (
        <>
            <Row className="m-2" align={"middle"}>
                <Col
                    xs={24}
                    sm={24}
                    md={9}
                    xl={6}
                    xxl={6}
                    className="d-flex justify-content-start font-bold"
                >
                    <h2 className="text-2xl">Reward Status</h2>
                </Col>
            </Row>
            <Row>
                <Col
                    style={{ backgroundColor: "#ffffff", borderRadius: "12px" }}
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={24}
                >
                    <Card className="bg-white border" style={{ borderRadius: "12px" }}>
                        <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
                            <div style={{ overflowX: 'auto' }}>
                                <p className='font-bold'>Valid From The Date of Joining</p>
                                <Table columns={columns} dataSource={PageData} scroll={{ x: true }} pagination={false} />
                            </div>
                        </Col>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default RewordStatus;